const initialState = {
  surveyCreationState: undefined,
};

const mutations = {
  surveyCreationState(state, to) {
    Object.assign(state, { surveyCreationState: to });
  },
};

const getters = {
  surveyCreationState: (state) => state.surveyCreationState,
};

export default {
  state: initialState,
  mutations,
  getters,
  namespaced: true,
};
